import { ExportPaymentKey } from '../enums';

export const DEFAULT_SELECT_OPTION = { label: 'All', value: '' };

export const PROPERTY_TRANSLATION = {
  [ExportPaymentKey.Id]: 'RequestPayment.Csv.Id',
  [ExportPaymentKey.SubscriptionRequestNumber]:
    'RequestPayment.Csv.SubscriptionRequestNumber',
  [ExportPaymentKey.SubscriptionRequestStatus]:
    'RequestPayment.Csv.SubscriptionRequestStatus',
  [ExportPaymentKey.SubscriptionTypeName]:
    'RequestPayment.Csv.SubscriptionTypeName',
  [ExportPaymentKey.User]: 'RequestPayment.Csv.User',
  [ExportPaymentKey.CreatedAt]: 'RequestPayment.Csv.Creation',
  [ExportPaymentKey.PaymentMethod]: 'RequestPayment.Csv.Method',
  [ExportPaymentKey.Type]: 'RequestPayment.Csv.Type',
  [ExportPaymentKey.PaidAmount]: 'RequestPayment.Csv.Amount',
  [ExportPaymentKey.BankDomiciliation]: 'RequestPayment.Csv.BankDomiciliation',
  [ExportPaymentKey.CheckNumber]: 'RequestPayment.Csv.CheckNumber',
  [ExportPaymentKey.PaymentConfig]: 'RequestPayment.Csv.PaymentConfig',
  [ExportPaymentKey.CtxContracts]: 'RequestPayment.Csv.PaymentContracts',
};
